export default __webpack_public_path__ + "static/media/hero-four.a5590f6b.jpg";